<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardHeader class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">{{ $lang.WithdrawalRequest.details }}</h5>
                    <CButton color="primary" @click="goBack">Back</CButton>
                </CCardHeader>
                <CCardBody v-if="selectedRequest">
                    <CRow>
                        <CCol md="6">
                            <p><strong>ID:</strong> {{ selectedRequest.id }}</p>
                            <p><strong>User Name:</strong> {{ selectedRequest.userName }}</p>
                            <p><strong>User Type:</strong> {{ selectedRequest.userType }}</p>
                            <p><strong>Payment Method:</strong> {{ selectedRequest.paymentMethod }}</p>
                            <!-- Status Section (Now in Single Line) -->
                            <div class="d-flex align-items-center">
                                <strong class="mr-2">Status:</strong>
                                <div class="status-box d-inline-flex align-items-center" :class="getStatusClass(selectedRequest.status)">
                                    <i :class="getStatusIcon(selectedRequest.status)"></i>
                                    <span>{{ selectedRequest.status }}</span>
                                </div>
                            </div>
                        </CCol>

                        <CCol md="6">
                            <p><strong>Transaction ID:</strong> {{ selectedRequest.transactionId }}</p>
                            <p><strong>Request Date:</strong> {{ formatDate(selectedRequest.requestDate) }}</p>
                            <p><strong>Transaction Date:</strong> {{ formatDate(selectedRequest.transactionDate) || 'N/A' }}</p>
                            <p><strong>Currency:</strong> {{ selectedRequest.currency.symbol }} ({{ selectedRequest.currency.currencyCode }})</p>
                        </CCol>
                    </CRow>

                    <!-- Bank Details Section -->
                    <CCard class="mt-4 shadow-sm">
                        <CCardHeader class="bg-primary text-white">
                            <h6 class="mb-0">Bank Details</h6>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol md="6">
                                    <p><strong>Bank Name:</strong> {{ selectedRequest.bankName }}</p>
                                    <p><strong>Account Holder:</strong> {{ selectedRequest.accountHolderName }}</p>
                                </CCol>
                                <CCol md="6">
                                    <p><strong>Account Number:</strong> {{ maskAccountNumber(selectedRequest.accountNumber) }}</p>
                                    <p><strong>IFSC Code:</strong> {{ selectedRequest.ifscCode }}</p>
                                    <p><strong>UPI ID:</strong> {{ selectedRequest.upiId || 'N/A' }}</p>
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>

                    <!-- Transaction Details Section -->
                    <CCard class="mt-4 shadow-sm">
                        <CCardHeader class="bg-success text-white">
                            <h6 class="mb-0">Transaction Details</h6>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol md="6">
                                    <p><strong>Total Points:</strong> {{ selectedRequest.currency.symbol + selectedRequest.totalPoints }}</p>
                                    <p><strong>Points:</strong> {{ selectedRequest.currency.symbol + selectedRequest.points }}</p>
                                </CCol>
                                <CCol md="6">
                                    <p><strong>Transaction Fee:</strong> {{ selectedRequest.currency.symbol + selectedRequest.transactionFee }}</p>
                                    <p><strong>GST:</strong> {{ selectedRequest.currency.symbol + selectedRequest.gst }}</p>
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>

                    <CRow v-if="selectedRequest.remark">
                        <CCol>
                            <CCard class="mt-4 shadow-sm">
                                <CCardHeader class="bg-warning text-white">
                                    <h6 class="mb-0">Remarks</h6>
                                </CCardHeader>
                                <CCardBody>
                                    <p>{{ selectedRequest.remark }}</p>
                                </CCardBody>
                            </CCard>
                        </CCol>
                    </CRow>
                    
                </CCardBody>

                <CCardFooter>
                    <CButton class="m-10" color="success" @click="cancelRequest" v-if="selectedRequest.status === 'Pending'">Pay</CButton><CButton class="m-10" color="danger" @click="cancelRequest" v-if="selectedRequest.status === 'Pending'">Reject Request</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import { withdrawalRequest } from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import { ServerTable } from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import { Maxlength } from "../../store/maxlength";
import store from "@/store/store";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
    name: "WithdrawalRequestView",
    mixins: [Mixin],
    data() {
        return {
            module: withdrawalRequest,
            messageColor: "success",
            err_msg: "",
            alertMessage: "",
            showAlert: false,
            dismissCountDown: 0,
            dismissCountDownS: 0,
            requestId: this.$route.params.id
        };
    },
    mounted() {
        store.commit('showLoader', false);
		// self.dismissCountDown = 0;
		// self.dismissCountDownS = 0;
		// if (localStorage.getItem("showAlert") !== "") {
		// 	this.setAlert(true);
		// }
		// this.setAlert(false);
		// localStorage.setItem("showAlert", "");
    },
    computed: {
		selectedRequest() {
			return this.$store.getters.getSelectedRequest;
		}
	},
    methods: {
        setAlert(value) {
			this.showAlert = value;
		},
        goBack() {
			this.$router.push("/withdrawal-request");
		},
        getStatusColor(status) {
			switch (status) {
				case "Pending":
					return "warning";
				case "Approved":
					return "success";
				case "Rejected":
					return "danger";
				default:
					return "secondary";
			}
		},
        getStatusClass(status) {
			switch (status) {
				case "Pending":
					return "status-pending";
				case "Approved":
				case "Completed":
					return "status-approved";
				case "Rejected":
				case "Cancelled":
					return "status-rejected";
				default:
					return "status-default";
			}
		},
		getStatusIcon(status) {
			switch (status) {
				case "Pending":
					return "fas fa-hourglass-half";
				case "Approved":
				case "Completed":
					return "fas fa-check-circle";
				case "Rejected":
				case "Cancelled":
					return "fas fa-times-circle";
				default:
					return "fas fa-info-circle";
			}
		},
		formatDate(date) {
			if (!date) return null;
			return new Date(date).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
		},
		maskAccountNumber(accountNumber) {
			return accountNumber.replace(/\d(?=\d{4})/g, "*");
		},
		cancelRequest() {
			alert("Are you sure you want to cancel this request?");
		}
    },
};
</script>
<style scoped>
.m-l-20 {
    margin-left: 20px;
}

.p-10 {
    padding: 10px;
}

.m-10 {
    margin: 10px;
}

.m-l-10 {
    margin-left: 10px;
}
/* Status Box */
.status-box {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.8rem;
	font-weight: bold;
	padding: 10px;
	border-radius: 8px;
	margin: 20px 0;
	text-transform: uppercase;
	box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.status-box i {
	margin-right: 10px;
	font-size: 1rem;
}

/* Status Colors */
.status-pending {
	background-color: #ffc107;
	color: #fff;
}

.status-approved {
	background-color: #28a745;
	color: #fff;
}

.status-rejected {
	background-color: #dc3545;
	color: #fff;
}

.status-default {
	background-color: #6c757d;
	color: #fff;
}

p {
	margin-bottom: 0.5rem;
}
h6 {
	margin-bottom: 0;
}
.shadow-sm {
	box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}
</style>